/**
 * Responsive Video Source Switching
 *
 * Swaps <source> src on self-hosted <video> elements based on viewport width.
 * Only targets .video-wrapper[data-responsive] elements with breakpoint data attributes.
 *
 * Breakpoints match the project's mobile-first SCSS breakpoints:
 * - Mobile: < 540px
 * - Tablet Portrait: 540px - 768px
 * - Tablet Landscape: 769px - 1023px
 * - Desktop: >= 1024px (default <source> element)
 *
 * @since 1.2.0
 */
(function () {
  var breakpoints = [
    { attr: "data-src-mobile", max: 539 },
    { attr: "data-src-tablet-portrait", min: 540, max: 768 },
    { attr: "data-src-tablet-landscape", min: 769, max: 1023 }
  ];

  function updateSources() {
    var wrappers = document.querySelectorAll(".video-wrapper[data-responsive]");
    var width = window.innerWidth;

    wrappers.forEach(function (wrapper) {
      // Skip lazy videos not yet loaded (managed by bn-video-lazy.js)
      if (wrapper.hasAttribute("data-lazy-video")) return;

      var video = wrapper.querySelector("video");
      var source = video && video.querySelector("source");
      if (!video || !source) return;

      // Store original desktop src on first run
      if (!wrapper.hasAttribute("data-src-desktop")) {
        wrapper.setAttribute("data-src-desktop", source.getAttribute("src") || "");
      }

      var newSrc = null;
      for (var i = 0; i < breakpoints.length; i++) {
        var bp = breakpoints[i];
        var src = wrapper.getAttribute(bp.attr);
        if (!src) continue;
        if ((!bp.min || width >= bp.min) && (!bp.max || width <= bp.max)) {
          newSrc = src;
          break;
        }
      }

      // Fallback to desktop source
      if (!newSrc) {
        newSrc = wrapper.getAttribute("data-src-desktop");
      }

      if (newSrc && source.getAttribute("src") !== newSrc) {
        source.src = newSrc;
        video.load();
      }
    });
  }

  // Run on load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", updateSources);
  } else {
    updateSources();
  }

  // Debounced resize (orientation change)
  var resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateSources, 300);
  });
})();
